module.exports = __webpack_public_path__ + "9885af688118568a6be87cc61ddffa60.svg";